<template>
  <div id="content-atividade">
    <div id="top-content-atividade">
      <Breadcrumb :items="breadcrumbItems" />
      <Carregamento v-if="carregando" />

      <div
        id="titulo-e-acoes"
        v-if="!carregando"
      >
        <div id="titulo-atividade">
          <div class="status-badge-wrapper">
            <span
              v-if="statusEfetivo === 'INSCRICOES_ABERTAS'"
              class="status-atividade aberta"
              ><i class="ti ti-edit"></i> Aberta</span
            >
            <span
              v-if="statusEfetivo === 'EM_EXECUCAO'"
              class="status-atividade em-andamento"
              ><i class="ti ti-player-play"></i> Em andamento</span
            >
            <span
              v-if="statusEfetivo === 'PROGRAMADA'"
              class="status-atividade programada"
              ><i class="ti ti-calendar"></i> Programada</span
            >
            <span
              v-if="
                dadosAtividade.status === 'FINALIZADO' ||
                dadosAtividade.status === 'CONCLUIDA'
              "
              class="status-atividade concluida"
              ><i class="ti ti-circle-check"></i> Concluída</span
            >
            <span
              v-if="dadosAtividade.status === 'CANCELADA'"
              class="status-atividade cancelada"
              ><i class="ti ti-circle-x"></i> Cancelada</span
            >
            <span
              v-if="dadosAtividade.status === 'ENCERRADA'"
              class="status-atividade encerrada"
              ><i class="ti ti-lock"></i> Encerrada</span
            >
            <!-- Badge: inscrições encerradas por data (status ainda não é ENCERRADA pelo backend) -->
            <span
              v-if="
                isPeriodoInscricaoEncerrado &&
                dadosAtividade.status !== 'EM_EXECUCAO' &&
                dadosAtividade.status !== 'ENCERRADA' &&
                dadosAtividade.status !== 'CANCELADA' &&
                dadosAtividade.status !== 'FINALIZADO' &&
                dadosAtividade.status !== 'CONCLUIDA'
              "
              class="status-atividade inscricoes-encerradas"
              ><i class="ti ti-calendar-off"></i> Inscrições encerradas</span
            >
            <span
              v-if="dadosAtividade.status === 'FINALIZANDO'"
              class="status-atividade finalizando"
              ><i class="ti ti-hourglass"></i> Finalizar</span
            >
          </div>

          <h2>{{ dadosAtividade.nome }}</h2>
        </div>

        <div class="header-actions">
          <div
            v-if="isInscrito && !carregando"
            class="inscricao-topo-container"
          >
            <span class="badge-inscrito-topo">
              <i class="ti ti-circle-check"></i> Você está inscrito(a)
            </span>
            <button
              v-if="statusEfetivo === 'INSCRICOES_ABERTAS'"
              class="btn-cancelar-inscricao-topo"
              @click="cancelarInscricao"
            >
              <i class="ti ti-user-x"></i> Cancelar inscrição
            </button>
          </div>

          <button
            v-else-if="
              podeSeInscrever &&
              !carregando
            "
            class="btn-inscrever-topo"
            @click="realizarInscricao"
          >
            <i class="ti ti-ticket"></i> Inscrever-se
          </button>

          <div
            id="botoes-coordenador"
            v-if="
              coordenador &&
              !['CANCELADA', 'ENCERRADA', 'FINALIZADO', 'CONCLUIDA'].includes(
                dadosAtividade.status
              )
            "
          >
            <button
              v-if="dadosAtividade.status !== 'EM_EXECUCAO'"
              class="btn-editar"
              @click="editarAtividade"
            >
              Editar
            </button>
            <button
              class="btn-cancelar-atividade"
              @click="cancelarAtividade"
            >
              Cancelar atividade
            </button>
          </div>

          <!-- Botões do Coordenador quando atividade ENCERRADA -->
          <div
            id="botoes-coordenador-encerrada"
            v-if="coordenador && dadosAtividade.status === 'ENCERRADA'"
          >
            <button
              class="btn-editar"
              @click="baixarCsvFrequencia"
              :disabled="baixandoCsv"
            >
              {{ baixandoCsv ? "Baixando..." : "CSV Frequência" }}
            </button>
          </div>

          <!-- Botões do Participante (Certificado removido conforme solicitação) -->
          <!-- 
          <div
            id="botoes-participante"
            v-if="
              isUsuarioLogado &&
              !podeVerInscritos &&
              (dadosAtividade.status === 'FINALIZADO' ||
                dadosAtividade.status === 'CONCLUIDA')
            "
          >
            <button class="btn-certificado" @click="baixarCertificado">
              ... svg ...
              Declaração
            </button>
          </div> 
          -->
        </div>
      </div>

      <div
        id="descricao-atividade"
        v-if="!carregando"
      >
        <p>Tipo: {{ formatarEnum(nomeSubtipo) || "Não informado" }}</p>
        <p>
          Modalidade de execução:
          {{ formatarEnum(dadosAtividade.modalidadeExecucao) }}
        </p>
        <p
          v-if="
            dadosAtividade.modalidadeInscricao ==
              'NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA' && coordenador
          "
        >
          Modalidade de inscrição: NÃO NESCESSITA DE INSCRIÇÃO E SEM FREQUÊNCIA
        </p>
        <p
          v-if="
            dadosAtividade.modalidadeInscricao ==
              'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA' && coordenador
          "
        >
          Modalidade de inscrição: NÃO NESCESSITA DE INSCRIÇÃO E COM FREQUÊNCIA
        </p>
        <p
          v-if="
            dadosAtividade.modalidadeInscricao ==
              'NESCESSITA_INSCRICAO_SEM_FREQUENCIA' && coordenador
          "
        >
          Modalidade de inscrição: NESCESSITA DE INSCRIÇÃO E SEM FREQUÊNCIA
        </p>
        <p
          v-if="
            dadosAtividade.modalidadeInscricao == 'NESCESSITA_INSCRICAO' &&
            coordenador
          "
        >
          Modalidade de inscrição: COM INSCRIÇÃO
        </p>
      </div>
    </div>

    <div
      id="conteudo"
      v-if="!carregando"
    >
      <section id="topo">
        <div id="img">
          <figure>
            <img :src="dadosAtividade.imagemUrl" />
          </figure>
        </div>

        <div id="coluna-direita-topo">
          <div id="descricao">
            <h6 id="rotulo-descricao">Descrição:</h6>
            <span id="conteudo-descricao">{{ dadosAtividade.descricao }}</span>
          </div>

          <div id="infos">
            <h6 id="rotulo-infos">INFORMAÇÕES</h6>
            <div class="infos-grid">
              <!-- Período de realização -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-calendar-event"></i> Período de Realização
                </div>
                <div class="info-value">{{ getPeriodoRealizacao() }}</div>
              </div>

              <!-- Local -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-map-pin"></i> Local
                </div>
                <div class="info-value">{{ dadosAtividade.local }}</div>
              </div>

              <!-- Período de inscrições (condicional) -->
              <div
                class="info-item"
                v-if="
                  dadosAtividade.dataInicioInscricao &&
                  dadosAtividade.dataFimInscricao
                "
              >
                <div class="info-label">
                  <i class="ti ti-calendar-time"></i> Período de Inscrições
                </div>
                <div class="info-value">
                  {{ formatarDataHora(dadosAtividade.dataInicioInscricao) }} a
                  {{ formatarDataHora(dadosAtividade.dataFimInscricao) }}
                </div>
              </div>

              <!-- Total de Vagas -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-users"></i> Total de Vagas
                </div>
                <div class="info-value">
                  {{
                    dadosAtividade.numeroDeVagasOfertadas
                      ? dadosAtividade.numeroDeVagasOfertadas
                      : "Ilimitadas"
                  }}
                </div>
              </div>

              <!-- Vagas Restantes -->
              <div
                class="info-item"
                v-if="
                  dadosAtividade.vagaAbertas !== undefined ||
                  dadosAtividade.vagasAbertas !== undefined ||
                  dadosAtividade.vagasRestantes !== undefined ||
                  dadosAtividade.numeroDeVagasOfertadas
                "
              >
                <div class="info-label">
                  <i class="ti ti-user-check"></i> Vagas Restantes
                </div>
                <div class="info-value">
                  <span
                    v-if="isCriterioCoordenacao"
                  >
                    Seleção da Coordenação
                  </span>
                  <span
                    v-else-if="
                      dadosAtividade.vagaAbertas === 0 ||
                      dadosAtividade.vagasAbertas === 0 ||
                      dadosAtividade.vagasRestantes === 0
                    "
                    class="vagas-esgotadas"
                  >
                    Vagas Esgotadas
                  </span>
                  <span
                    v-else-if="
                      dadosAtividade.vagaAbertas != null ||
                      dadosAtividade.vagasAbertas != null ||
                      dadosAtividade.vagasRestantes != null
                    "
                  >
                    {{
                      dadosAtividade.vagaAbertas ??
                      dadosAtividade.vagasAbertas ??
                      dadosAtividade.vagasRestantes
                    }}
                  </span>
                  <span v-else>
                    {{
                      dadosAtividade.numeroDeVagasOfertadas
                        ? dadosAtividade.numeroDeVagasOfertadas
                        : "Ilimitadas"
                    }}
                  </span>
                </div>
              </div>

              <!-- Inscrição / Modalidade -->
              <div
                class="info-item"
                v-if="dadosAtividade.modalidadeInscricao"
              >
                <div class="info-label">
                  <i class="ti ti-file-text"></i> Inscrição
                </div>
                <div class="info-value">
                  <span>
                    {{
                      isCriterioCoordenacao
                        ? "Critério da Coordenação"
                        : dadosAtividade.criterioInscricao === "ORDEMDEINSCRICAO"
                        ? "Ordem de Inscrição"
                        : formatarEnum(dadosAtividade.modalidadeInscricao)
                    }}
                  </span>
                </div>
              </div>

              <!-- Como funciona a inscrição -->
              <div
                class="info-item info-item-explicacao"
                v-if="explicacaoInscricao"
              >
                <div class="info-label">
                  <i class="ti ti-info-circle"></i> Como funciona a inscrição
                </div>
                <div class="info-value info-explicacao-texto">
                  {{ explicacaoInscricao }}
                </div>
              </div>

              <!-- Link para formulário da coordenação se houver -->
              <div
                class="info-item"
                v-if="dadosAtividade.linkFormulario"
              >
                <div class="info-label">
                  <i class="ti ti-external-link"></i> Formulário da Coordenação
                </div>
                <div class="info-value">
                  <a
                    :href="formatarUrlExterna(dadosAtividade.linkFormulario)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-formulario-externo"
                  >
                    <i class="ti ti-link"></i> Acessar formulário
                  </a>
                </div>
              </div>
            </div>

            <!-- Botão Ver Lista de Inscritos embaixo de Informações -->
            <div
              class="infos-rodape"
              v-if="isCoordenadorAcao"
            >
              <button
                class="btn-ver-inscritos-card"
                @click="verInscritos"
              >
                <i class="ti ti-users"></i> Ver lista de inscritos
              </button>
            </div>
          </div>
        </div>
      </section>

      <hr />

      <section id="inferior">
        <div id="encontros">
          <div class="encontros-cabecalho">
            <div class="encontros-titulo-area">
              <h6 style="margin: 0">Encontros</h6>
              <span class="badge-contador" v-if="encontrosFiltrados?.length">
                {{ encontrosFiltrados.length }}
              </span>
            </div>
            <button
              v-if="
                coordenador &&
                (viaAcao || dadosAtividade?.acaoExtensaoId || dadosAtividade?.acaoId) &&
                !['CANCELADA', 'ENCERRADA', 'FINALIZADO', 'CONCLUIDA'].includes(
                  dadosAtividade.status
                )
              "
              class="btn-editar-encontros"
              @click="editarEncontros"
            >
              <i class="ti ti-edit"></i> Editar Encontros
            </button>
          </div>

          <div v-if="encontros?.length">
            <div
              id="body-encontros"
              v-for="encontro in encontrosFiltrados"
              :key="encontro.encontroId"
            >
              <div
                class="infos-encontros"
                :class="{ 'is-expanded': encontroExpandido === encontro.encontroId }"
              >
                <div
                  class="encontro"
                  @click="mostrarDescricao(encontro.encontroId)"
                >
                  <div class="encontro-titulo">
                    <i
                      class="ti ti-chevron-down encontro-chevron"
                      :class="{ 'is-rotated': encontroExpandido === encontro.encontroId }"
                    ></i>
                    <span>{{ encontro.titulo }}</span>
                  </div>

                  <div
                    class="encontro-status-badge"
                    :class="encontro.status?.toLowerCase()"
                  >
                    <span v-if="encontro.status === 'PROGRAMADO'">
                      <i class="ti ti-calendar-time"></i>
                      {{ formatarData(encontro.inicio_periodo) }} às
                      {{
                        formatarDataHora(encontro.inicio_periodo).split(" ")[1]
                      }}
                    </span>
                    <span v-else-if="encontro.status === 'EM_EXECUCAO'">
                      <i class="ti ti-player-play"></i>
                      Em andamento -
                      {{
                        formatarDataHora(encontro.inicio_periodo).split(" ")[1]
                      }}
                      às
                      {{
                        formatarDataHora(encontro.fim_periodo).split(" ")[1]
                      }}
                    </span>
                    <span v-else-if="encontro.status === 'FINALIZADO'">
                      <i class="ti ti-circle-check"></i>
                      Concluído em {{ formatarData(encontro.fim_periodo) }}
                    </span>
                    <span v-else-if="encontro.status === 'CANCELADO'">
                      <i class="ti ti-circle-x"></i>
                      Cancelado
                    </span>
                    <span v-else-if="encontro.status === 'INSCRICOES_ABERTAS'">
                      <i class="ti ti-ticket"></i>
                      Inscrições abertas
                    </span>
                    <span v-else>
                      {{ encontro.status }}
                    </span>
                  </div>
                </div>

                <transition name="accordion">
                  <div
                    v-if="encontroExpandido === encontro.encontroId"
                    class="descricao-encontros"
                  >
                    <div class="descricao-texto">
                      <strong>Descrição:</strong>
                      <span>{{ encontro.descricao || "Nenhuma descrição informada para este encontro." }}</span>
                    </div>
                    <div
                      v-if="
                        coordenador &&
                        (encontro.status === 'EM_EXECUCAO' ||
                          (podeVerInscritos &&
                            encontro.status !== 'CANCELADO' &&
                            dadosAtividade.modalidadeInscricao ===
                              'NESCESSITA_INSCRICAO' &&
                            isPeriodoInscricaoEncerrado))
                      "
                      class="encontro-acoes"
                    >
                      <button
                        v-if="
                          coordenador &&
                          viaAcao &&
                          encontro.status === 'EM_EXECUCAO'
                        "
                        class="btn-concluir-encontro"
                        @click.stop="concluirEncontro(encontro.encontroId)"
                      >
                        <i class="ti ti-check"></i> Concluir Encontro
                      </button>
                      <button
                        v-if="
                          coordenador &&
                          viaAcao &&
                          podeVerInscritos &&
                          encontro.status !== 'CANCELADO' &&
                          dadosAtividade.modalidadeInscricao ===
                            'NESCESSITA_INSCRICAO' &&
                          isPeriodoInscricaoEncerrado
                        "
                        class="btn-baixar-lista"
                        @click.stop="baixarListaAssinatura(encontro.encontroId)"
                      >
                        <i class="ti ti-download"></i> Baixar Lista
                      </button>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div v-else class="encontros-vazio">
            <i class="ti ti-calendar-off"></i>
            <p>Nenhum encontro encontrado.</p>
          </div>
        </div>

        <div class="coluna-direita-inferior">
          <div
            id="objetivos-relacionados"
            v-if="dadosAtividade.status !== 'CANCELADA'"
          >
            <h6>OBJETIVO(S) RELACIONADO(S)</h6>
            <div
              v-if="
                dadosAtividade.objetivos && dadosAtividade.objetivos.length > 0
              "
            >
              <div
                v-for="obj in dadosAtividade.objetivos"
                :key="obj.id"
                class="objetivo-relacionado-item"
              >
                <p class="objetivo-titulo">
                  {{ obj.titulo }}
                </p>
              </div>
            </div>
            <p v-else>Nenhum objetivo relacionado encontrado.</p>
          </div>

          <div
            id="acoes-coordenador"
            v-if="
              coordenador &&
              viaAcao &&
              [
                'PROGRAMADA',
                'EM_EXECUCAO',
                'FINALIZANDO',
                'ENCERRADA',
                'FINALIZADO',
                'CONCLUIDA',
              ].includes(dadosAtividade.status)
            "
          >
            <h6>AÇÕES DO COORDENADOR</h6>
            <div id="opcoes">
              <button
                @click="abrirModal('realizarFrequencia')"
                v-if="
                  ['PROGRAMADA', 'EM_EXECUCAO', 'FINALIZANDO'].includes(
                    dadosAtividade.status
                  ) &&
                  (dadosAtividade.modalidadeInscricao ==
                    'NESCESSITA_INSCRICAO' ||
                    dadosAtividade.modalidadeInscricao ==
                      'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA')
                "
              >
                Realizar frequência
              </button>
              <button
                @click="baixarMapaFrequencia"
                v-if="
                  (dadosAtividade.modalidadeInscricao ==
                    'NESCESSITA_INSCRICAO' ||
                    dadosAtividade.modalidadeInscricao ==
                      'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA') &&
                  encontros.some((e) => e.status === 'FINALIZADO')
                "
              >
                Mapa Frequência
              </button>
              <button
                @click="escolherParticipantes = true"
                v-if="
                  ['PROGRAMADA', 'EM_EXECUCAO', 'FINALIZANDO'].includes(
                    dadosAtividade.status
                  ) &&
                  dadosAtividade.modalidadeInscricao ==
                    'NESCESSITA_INSCRICAO' &&
                  dadosAtividade.criterioInscricao == 'CRITERIODACOORDENACAO'
                "
              >
                Escolher Participantes
              </button>

              <button
                @click="editarCargos = true"
                v-if="
                  ['PROGRAMADA', 'EM_EXECUCAO', 'FINALIZANDO'].includes(
                    dadosAtividade.status
                  )
                "
              >
                Criar equipe
              </button>

              <button
                v-if="dadosAtividade.status === 'EM_EXECUCAO'"
                @click="concluirAtividade"
                class="btn-concluir-atividade"
              >
                Concluir Atividade
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div
      class="confirmacao"
      v-if="dadosAtividade.status === 'CANCELADA' && !carregando"
    >
      <p>
        A atividade foi cancelada em
        {{
          formatarData(
            dadosAtividade.dataCancelamento ||
              dadosAtividade.dataFimRealizacao ||
              dadosAtividade.dataFimInscricao
          ) || "data não informada"
        }}
      </p>
    </div>

    <!-- Banner: Atividade ENCERRADA pelo responsável OU período de realização encerrado -->
    <div
      class="confirmacao"
      v-if="
        (dadosAtividade.status === 'ENCERRADA' || isPeriodoRealizacaoEncerrado) &&
        dadosAtividade.status !== 'CANCELADA' &&
        !carregando
      "
    >
      <p>
        Esta atividade foi encerrada dia
        {{ getDataEncerramentoOuFimRealizacao() }}.
      </p>
    </div>

    <!-- Banner: Quando o usuário já está inscrito e a atividade não encerrou a realização -->
    <div
      v-if="
        isInscrito &&
        !isPeriodoRealizacaoEncerrado &&
        dadosAtividade.status !== 'ENCERRADA' &&
        dadosAtividade.status !== 'CANCELADA' &&
        !carregando
      "
      class="confirmacao confirmacao-inscrito"
    >
      <div class="confirmacao-texto-bloco">
        <p class="confirmacao-titulo">
          <i class="ti ti-circle-check"></i> Você já está inscrito(a) nesta atividade!
        </p>
        <p
          class="confirmacao-subtexto"
          v-if="isPeriodoInscricaoEncerrado && isCriterioCoordenacao"
        >
          O período de inscrições foi encerrado em {{ formatarDataHora(dadosAtividade.dataFimInscricao) }}. A coordenação selecionará os participantes compatíveis com as vagas ofertadas.
        </p>
        <p
          class="confirmacao-subtexto"
          v-else-if="isCriterioCoordenacao"
        >
          Sua inscrição foi registrada com sucesso. Ao término do período de inscrições, a coordenação selecionará os participantes compatíveis com as vagas ofertadas.
        </p>
        <p
          class="confirmacao-subtexto"
          v-else-if="isPeriodoInscricaoEncerrado"
        >
          O período de inscrições para esta atividade foi encerrado em {{ formatarDataHora(dadosAtividade.dataFimInscricao) }}.
        </p>
      </div>
      <button
        v-if="statusEfetivo === 'INSCRICOES_ABERTAS' && !isPeriodoInscricaoEncerrado"
        class="btn-desinscrever-banner"
        @click="cancelarInscricao"
      >
        <i class="ti ti-user-x"></i> Cancelar inscrição
      </button>
    </div>

    <!-- Banner: Período de inscrições encerrado por data (quando o usuário não está inscrito) -->
    <div
      class="confirmacao confirmacao-inscricoes-encerradas"
      v-if="
        !isInscrito &&
        isPeriodoInscricaoEncerrado &&
        !isPeriodoRealizacaoEncerrado &&
        dadosAtividade.status !== 'EM_EXECUCAO' &&
        dadosAtividade.status !== 'ENCERRADA' &&
        dadosAtividade.status !== 'CANCELADA' &&
        dadosAtividade.status !== 'FINALIZADO' &&
        dadosAtividade.status !== 'CONCLUIDA' &&
        !carregando
      "
    >
      <div class="confirmacao-texto-bloco">
        <p class="confirmacao-titulo">
          <i class="ti ti-calendar-off"></i> Período de inscrições encerrado
        </p>
        <p class="confirmacao-subtexto">
          As inscrições para esta atividade foram encerradas em
          {{ formatarDataHora(dadosAtividade.dataFimInscricao) }}.
        </p>
      </div>
    </div>

    <div
      class="confirmacao"
      v-if="
        (dadosAtividade.status === 'EM_EXECUCAO' || dadosAtividade.status === 'FINALIZANDO') &&
        !isPeriodoRealizacaoEncerrado &&
        !carregando
      "
    >
      <p>A atividade está em andamento</p>
    </div>

    <div
      class="confirmacao"
      v-if="
        statusEfetivo === 'PROGRAMADA' &&
        !isPeriodoInscricaoEncerrado &&
        !isPeriodoRealizacaoEncerrado &&
        !isInscrito &&
        !carregando
      "
    >
      <p v-if="dadosAtividade.dataInicioInscricao && isAntesDeAbrirInscricao">
        As inscrições estão programadas para abrir dia
        {{ formatarDataHora(dadosAtividade.dataInicioInscricao) }}
      </p>
      <p v-else>
        A atividade está programada para iniciar dia
        {{ getPeriodoRealizacao().split(" - ")[0] }}
      </p>
    </div>

    <div
      class="confirmacao"
      v-if="
        (statusEfetivo === 'FINALIZADO' || statusEfetivo === 'CONCLUIDA') &&
        !isPeriodoRealizacaoEncerrado &&
        dadosAtividade.status !== 'ENCERRADA' &&
        !carregando
      "
    >
      <p>
        A atividade foi concluída em
        {{
          formatarData(
            dadosAtividade.dataConclusao ||
              dadosAtividade.dataEncerramento ||
              dadosAtividade.dataFimRealizacao ||
              dadosAtividade.dataFimInscricao
          ) || "data não informada"
        }}
      </p>
    </div>

    <div
      v-if="
        statusEfetivo === 'INSCRICOES_ABERTAS' &&
        !isInscrito &&
        !isPeriodoInscricaoEncerrado &&
        !isPeriodoRealizacaoEncerrado &&
        !carregando
      "
    >
      <div
        class="confirmacao"
        v-if="
          dadosAtividade.modalidadeInscricao.includes(
            'NAO_NESCESSITA_INSCRICAO'
          )
        "
      >
        <p>A atividade está aberta para inscrições</p>
      </div>

      <div
        v-else
        class="confirmacao confirmacao-aberta"
      >
        <div v-if="isVagasEsgotadas" class="confirmacao-texto-bloco">
          <p class="confirmacao-titulo" style="color: #d32f2f;">
            <i class="ti ti-alert-circle"></i> Vagas esgotadas!
          </p>
          <p class="confirmacao-subtexto">
            Todas as vagas disponíveis para esta atividade foram preenchidas.
          </p>
        </div>
        <div v-else class="confirmacao-texto-bloco">
          <p class="confirmacao-titulo">A atividade está com inscrições abertas!</p>
          <p class="confirmacao-subtexto" v-if="explicacaoInscricao">
            {{ explicacaoInscricao }}
          </p>
        </div>
        <button
          v-if="podeSeInscrever"
          class="btn-inscrever-banner"
          @click="realizarInscricao"
        >
          <i class="ti ti-ticket"></i> Inscrever-se nesta atividade
        </button>
      </div>
    </div>

    <!-- ======================================================= -->
    <!-- Modal de confirmação de cancelamento                     -->
    <!-- ======================================================= -->
    <div
      v-if="mostrarModalCancelamento"
      class="overlay-cancelamento"
    >
      <div class="modal-cancelamento">
        <h6>Cancelar atividade</h6>
        <p>
          Tem certeza que deseja cancelar a atividade
          <strong>{{ dadosAtividade.nome }}</strong
          >? Essa ação não pode ser desfeita.
        </p>
        <div class="modal-cancelamento-botoes">
          <button
            class="btn-confirmar-cancelamento"
            @click="confirmarCancelamento"
          >
            Sim, cancelar
          </button>
          <button
            class="btn-voltar-cancelamento"
            @click="mostrarModalCancelamento = false"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="escolherParticipantes">
    <ParticipantesAtividade
      :atividadeId="props.atividadeId"
      @fecharEscolherParticipantes="escolherParticipantes = false"
    />
  </div>
  <div v-else-if="editarCargos">
    <GestaoDeEquipe
      :acaoId="acaoId"
      :atividadeId="props.atividadeId"
      @fecharGestaoDeEquipe="editarCargos = false"
    />
  </div>

  <ListaInscritos
    v-if="mostrarModalInscritos"
    :atividadeId="props.atividadeId"
    :isCoordenador="coordenador"
    :criterioInscricao="dadosAtividade?.criterioInscricao"
    @fechar="mostrarModalInscritos = false"
    @atualizar="carregarAtividade"
  />

  <RouterView />

  <FrequenciaEncontro
    v-if="route.query.modal === 'realizarFrequencia'"
    @fechar="fecharModal()"
  />

  <FormEditarAtividade
    v-if="
      (route.query.modal === 'editarAtividade' ||
        route.query.modal === 'editarEncontros') &&
      atividade
    "
    :dados="atividade"
    :atividadeId="props.atividadeId"
    :acaoId="route.params.id"
    :abrirEncontrosDireto="route.query.modal === 'editarEncontros'"
    @fechar-form-atividade="fecharModal()"
  />

  <ModalLoginObrigatorio
    :visivel="mostrarModalLogin"
    :nomeAtividade="dadosAtividade?.nome"
    @fechar="mostrarModalLogin = false"
  />
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import ParticipantesAtividade from "@/components/atividades/ParticipantesAtividade.vue";
import GestaoDeEquipe from "@/components/atividades/GestaoDeEquipe.vue";
import FrequenciaEncontro from "@/components/encontros/FrequenciaEncontro.vue";
import { formatarData, formatarDataHora } from "@/utils/FormatarEntradas";
import { formatarEnum } from "@/utils/FormatarEntradas";
import encontrosService from "@/service/encontrosService.js";
import participantesAtividadeService from "@/service/participantesAtividadeService";
import certificadoService from "@/service/certificadoService.js";
import frequenciaService from "@/service/frequenciaService";
import userInfos from "@/utils/userInfos";
import objetivosService from "@/service/objetivosService";
import atividadeService from "@/service/atividadeService";
import router from "@/router";
import { useRoute } from "vue-router";
import acaoService from "@/service/acaoService";
import FormEditarAtividade from "@/components/atividades/FormEditarAtividade.vue";
import ListaInscritos from "@/components/atividades/ListaInscritos.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import ModalLoginObrigatorio from "@/components/common/ModalLoginObrigatorio.vue";
import { useAtividades } from "@/composables/useAtividades";
import { useToast } from "@/composables/useToast";

const toast = useToast();

const carregando = ref(false);
const isInscrito = ref(false);
const encontros = ref([]);
const filtroEncontros = ref("");
const encontroExpandido = ref(null);
const escolherParticipantes = ref(false);
const editarCargos = ref(false);
const baixandoCsv = ref(false);
const atividade = ref();
const resolvedSubtipoNome = ref("");
const nomeSubtipo = ref('')
const coordenador = ref(false);
const podeVerInscritos = ref(false);
const isCoordenadorAcao = ref(false);
const isUsuarioLogado = ref(false);
// Cache para evitar chamadas duplicadas ao endpoint verificar-coordenador
let _permissaoVerificadaParaAcaoId = null;
const dadosAcao = ref(null);
const mostrarModalCancelamento = ref(false);
const mostrarModalInscritos = ref(false);
const mostrarModalLogin = ref(false);
const route = useRoute();

const {subtipo, fetchSubTipoPorId} = useAtividades();

const emit = defineEmits(["titulo", "fechar-atividade"]);

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id;
  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "Atividades", to: `/acao/${acaoId}/Atividades` },
      {
        label: dadosAtividade.value.nome,
        to: `/acao/${acaoId}/Atividades/${props.atividadeId}`,
      },
    ];
  } else {
    return [
      { label: "Início", to: "/" },
      { label: "Atividades", to: "/atividades" },
      {
        label: dadosAtividade.value.nome,
        to: `/atividades/${props.atividadeId}`,
      },
    ];
  }
});

const props = defineProps({
  acaoId: String,
  atividadeId: String,
});

const viaAcao = computed(() => !!route.params.id);

async function verificarPermissaoVerInscritos() {
  podeVerInscritos.value = false;
  coordenador.value = false;
  isCoordenadorAcao.value = false;
  const user = userInfos.getUserInfos();
  if (!user) {
    return;
  }

  const targetAtividadeId =
    props.atividadeId || route.params.atividadeId || route.params.id;
  const targetAcaoId =
    props.acaoId ||
    route.params.id ||
    dadosAtividade.value?.acaoExtensaoId ||
    dadosAtividade.value?.acaoId ||
    atividade.value?.acaoExtensaoId ||
    atividade.value?.acaoId;

  const scopes = user.scope ? user.scope.split(" ") : [];
  const scopesAdm = [
    "SCOPE_ADMINISTRADOR",
    "SCOPE_PREX",
    "ADMIN",
    "ADMINISTRADOR",
    "PREX",
  ];

  // 1. Apenas Administradores e PREX possuem acesso global
  const ehAdm = scopes.some((s) => scopesAdm.includes(s));
  if (ehAdm) {
    podeVerInscritos.value = true;
    coordenador.value = true;
    isCoordenadorAcao.value = true;
    _permissaoVerificadaParaAcaoId = targetAcaoId;
    return;
  }

  // 2. Coordenador da ação desta atividade especificamente
  // Usa cache para evitar múltiplas chamadas ao endpoint verificar-coordenador (429)
  if (targetAcaoId) {
    if (_permissaoVerificadaParaAcaoId === targetAcaoId) {
      // Já verificou para este acaoId nesta sessão, não chamar de novo
      return;
    }
    try {
      const isCoord = await acaoService.verificarCoordenador(targetAcaoId);
      _permissaoVerificadaParaAcaoId = targetAcaoId;
      if (isCoord) {
        podeVerInscritos.value = true;
        coordenador.value = true;
        isCoordenadorAcao.value = true;
        return;
      }
    } catch (e) {
      console.error("Erro ao verificar coordenador da ação:", e);
    }
  }

  // 3. Líder desta atividade específica
  if (targetAtividadeId) {
    try {
      const ehLider =
        await userInfos.verificarLiderancaAtividade(targetAtividadeId);
      if (ehLider) {
        podeVerInscritos.value = true;
        coordenador.value = true;
        return;
      }
    } catch (error) {
      console.error("Erro ao verificar se o usuário é líder:", error);
    }
  }
}

async function cancelarAtividade() {
  const confirmar = confirm("Tem certeza que deseja cancelar esta atividade?");

  if (!confirmar) {
    return;
  }

  const response = await atividadeService.cancelarAtividade(atividade.value.id);
  mostrarModalCancelamento.value = false;
  if (response.status === 200) {
    alert("Atividade cancelada com sucesso!");
    carregarAtividade();
  } else {
    alert("Não foi possível cancelar a atividade. Tente novamente.");
  }
}

async function carregarAtividade() {
  atividade.value =
    (await atividadeService.getAtividadeId(props.atividadeId)) ||
    route.params.atividadeId;

  resolvedSubtipoNome.value = "";
  if (atividade.value) {
    await fetchSubTipoPorId(atividade.value.subtipoId)
    nomeSubtipo.value = subtipo.value.nome
  }

  await analiseInscricao();
  await buscarEncontros();
}

async function carregarAcao() {
  if (!route.params.id) {
    dadosAcao.value = null;
    return;
  }

  try {
    dadosAcao.value = await acaoService.getAcoesById(route.params.id);
  } catch (error) {
    console.error("Erro ao carregar dados da ação:", error);
    dadosAcao.value = null;
  }
}

function mudarRota() {
  router.back();
}

function verificarAcoesCoord() {
  return (
    coordenador &&
    !["CANCELADA", "ENCERRADA", "FINALIZADO"].includes(dadosAtividade.status) &&
    route.params.id
  );
}

function editarAtividade() {
  const targetAcaoId =
    props.acaoId ||
    route.params.id ||
    dadosAtividade.value?.acaoExtensaoId ||
    dadosAtividade.value?.acaoId;
  const targetAtividadeId =
    props.atividadeId || route.params.atividadeId || atividade.value?.id;
  if (targetAcaoId && targetAtividadeId) {
    router.push({
      name: "editar-atividade",
      params: { id: targetAcaoId, atividadeId: targetAtividadeId },
    });
  }
}

function editarEncontros() {
  const targetAcaoId =
    props.acaoId ||
    route.params.id ||
    dadosAtividade.value?.acaoExtensaoId ||
    dadosAtividade.value?.acaoId;
  const targetAtividadeId =
    props.atividadeId || route.params.atividadeId || atividade.value?.id;
  if (targetAcaoId && targetAtividadeId) {
    router.push({
      name: "editar-encontros-atividade",
      params: { id: targetAcaoId, atividadeId: targetAtividadeId },
    });
  }
}

function abrirModal(modal) {
  router.push({
    query: {
      modal: modal,
      atividade: props.atividadeId,
    },
  });
}

function fecharModal() {
  router.push({ query: {} });
}

function verInscritos() {
  mostrarModalInscritos.value = true;
}

const dadosAtividade = computed(
  () =>
    atividade.value || {
      nome: "Nome Padrão",
      descricao: "Descrição padrão",
      status: "PROGRAMADA",
      tipo: "CURSO",
      modalidadeExecucao: "PRESENCIAL",
      modalidadeInscricao: "NESCESSITA_INSCRICAO",
      criterioInscricao: "ORDEMDEINSCRICAO",
      numeroDeVagasOfertadas: 10,
      local: "Local Padrão",
      dataInicioInscricao: "2025-01-16T00:00:00",
      dataFimInscricao: "2025-01-22T00:00:00",
      imagemUrl: "https://bucket.nerds.cloudns.be/gex-dev/imagemDefault.jpeg",
      acaoUrl: "",
    }
);

const isCriterioCoordenacao = computed(() => {
  const criterio = dadosAtividade.value?.criterioInscricao;
  return (
    criterio === "CRITERIODACOORDENACAO" ||
    criterio === "CRITERIO_DA_COORDENACAO" ||
    criterio === "Critério da Coordenação"
  );
});

const explicacaoInscricao = computed(() => {
  if (dadosAtividade.value?.modalidadeInscricao !== "NESCESSITA_INSCRICAO") {
    return "";
  }
  if (isCriterioCoordenacao.value) {
    return "Nesta atividade, todos os interessados podem se inscrever livremente. Ao término do período de inscrições, a coordenação selecionará os participantes compatíveis com o número de vagas ofertadas.";
  }
  return "As vagas são preenchidas automaticamente por ordem de inscrição (os primeiros inscritos garantem a vaga até o limite total).";
});

function formatarUrlExterna(url) {
  if (!url) return "#";
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
}

const agora = ref(Date.now());
let timerInterval = null;

const isAntesDeAbrirInscricao = computed(() => {
  if (dadosAtividade.value?.modalidadeInscricao !== "NESCESSITA_INSCRICAO") {
    return false;
  }
  if (!dadosAtividade.value?.dataInicioInscricao) return false;
  const dataInicio = new Date(dadosAtividade.value.dataInicioInscricao).getTime();
  if (isNaN(dataInicio)) return false;
  return agora.value < dataInicio;
});

const isPeriodoInscricaoEncerrado = computed(() => {
  if (dadosAtividade.value?.modalidadeInscricao !== "NESCESSITA_INSCRICAO") {
    return false;
  }
  if (!dadosAtividade.value?.dataFimInscricao) return false;
  const dataFim = new Date(dadosAtividade.value.dataFimInscricao).getTime();
  if (isNaN(dataFim)) return false;
  return agora.value > dataFim;
});

const isPeriodoRealizacaoEncerrado = computed(() => {
  let dataFim =
    dadosAtividade.value?.dataEncerramento ||
    dadosAtividade.value?.dataFimRealizacao;
  if (!dataFim && encontros.value?.length > 0) {
    dataFim = encontros.value[encontros.value.length - 1]?.fim_periodo;
  }
  if (!dataFim) return false;
  const time = new Date(dataFim).getTime();
  if (isNaN(time)) return false;
  return agora.value > time;
});

function getDataEncerramentoOuFimRealizacao() {
  let data =
    dadosAtividade.value?.dataEncerramento ||
    dadosAtividade.value?.dataFimRealizacao;
  if (!data && encontros.value?.length > 0) {
    data = encontros.value[encontros.value.length - 1]?.fim_periodo;
  }
  if (!data) {
    data = dadosAtividade.value?.dataFimInscricao;
  }
  return data ? formatarData(data) : "data não informada";
}

const isVagasEsgotadas = computed(() => {
  if (isCriterioCoordenacao.value) return false;
  const vagas =
    dadosAtividade.value?.vagaAbertas ??
    dadosAtividade.value?.vagasAbertas ??
    dadosAtividade.value?.vagasRestantes;
  if (vagas !== undefined && vagas !== null) {
    return Number(vagas) === 0;
  }
  return false;
});

const statusEfetivo = computed(() => {
  if (!dadosAtividade.value?.status) return "";
  if (
    [
      "CANCELADA",
      "ENCERRADA",
      "FINALIZADO",
      "CONCLUIDA",
      "EM_EXECUCAO",
      "FINALIZANDO",
    ].includes(dadosAtividade.value.status)
  ) {
    return dadosAtividade.value.status;
  }
  if (dadosAtividade.value.modalidadeInscricao === "NESCESSITA_INSCRICAO") {
    if (isAntesDeAbrirInscricao.value) {
      return "PROGRAMADA";
    }
    // Quando encerra período de inscrições, a atividade permanece PROGRAMADA (não ENCERRADA)
    if (isPeriodoInscricaoEncerrado.value) {
      return "PROGRAMADA";
    }
  }
  return dadosAtividade.value.status;
});

const podeSeInscrever = computed(() => {
  if (isInscrito.value) return false;
  if (dadosAtividade.value?.modalidadeInscricao !== "NESCESSITA_INSCRICAO") {
    return false;
  }
  if (isVagasEsgotadas.value) return false;
  return (
    statusEfetivo.value === "INSCRICOES_ABERTAS" &&
    !isAntesDeAbrirInscricao.value &&
    !isPeriodoInscricaoEncerrado.value
  );
});

const encontrosFiltrados = computed(() => {
  return encontros.value.filter((encontro) => {
    return encontro.status.includes(filtroEncontros.value);
  });
});

function mostrarDescricao(id) {
  encontroExpandido.value = encontroExpandido.value === id ? null : id;
}

function getPeriodoRealizacao() {
  if (!encontros.value || encontros.value.length === 0) {
    if (
      dadosAtividade.value?.dataInicioRealizacao &&
      dadosAtividade.value?.dataFimRealizacao
    ) {
      return (
        formatarData(dadosAtividade.value.dataInicioRealizacao) +
        " - " +
        formatarData(dadosAtividade.value.dataFimRealizacao)
      );
    }
    return "A definir";
  }
  const dataFimRealizacao = Object(
    encontros.value[encontros.value.length - 1]
  ).fim_periodo;
  const dataInicioRealizacao = Object(encontros.value[0]).inicio_periodo;
  const dataFimFormatada =
    dataFimRealizacao !== null
      ? formatarData(dataFimRealizacao)
      : "Sem data final";
  return formatarData(dataInicioRealizacao) + " - " + dataFimFormatada;
}

function isUsuarioAutenticado() {
  const user = userInfos.getUserInfos();
  const token = window.localStorage.getItem("auth_token");
  if (!user || !user.userId || !token) {
    return false;
  }
  return !userInfos.tokenExpirado(user);
}

async function realizarInscricao() {
  if (isPeriodoInscricaoEncerrado.value) {
    toast.aviso("O período de inscrições para esta atividade já foi encerrado.", {
      titulo: "Inscrições encerradas",
    });
    return;
  }

  if (isAntesDeAbrirInscricao.value) {
    toast.aviso("O período de inscrições para esta atividade ainda não foi iniciado.", {
      titulo: "Inscrições não iniciadas",
    });
    return;
  }

  if (isVagasEsgotadas.value) {
    toast.aviso("As vagas para esta atividade estão esgotadas.", {
      titulo: "Vagas esgotadas",
    });
    return;
  }

  if (!isUsuarioAutenticado()) {
    mostrarModalLogin.value = true;
    return;
  }

  const user = userInfos.getUserInfos();

  const userId = user.userId;
  const targetId = props.atividadeId || route.params.atividadeId || atividade.value?.id;
  if (!targetId) {
    toast.erro("Identificador da atividade não encontrado.", {
      titulo: "Erro",
    });
    return;
  }

  try {
    carregando.value = true;
    await participantesAtividadeService.postParticipanteAtividade(userId, targetId);

    isInscrito.value = true;

    toast.sucesso("Inscrição realizada com sucesso!", {
      titulo: "Inscrição confirmada",
      duracao: 5000,
    });

    await carregarAtividade();
    await analiseInscricao();
  } catch (error) {
    console.error("Erro ao realizar inscrição:", error);
    toast.erro(
      error?.response?.data?.message ||
      error?.message ||
      "Erro ao realizar inscrição. Tente novamente.",
      { titulo: "Não foi possível inscrever" }
    );
  } finally {
    carregando.value = false;
  }
}

async function cancelarInscricao() {
  const user = userInfos.getUserInfos();
  if (!user) return;

  const confirmar = confirm(
    "Deseja realmente cancelar sua inscrição nesta atividade?"
  );
  if (!confirmar) return;

  const targetId =
    props.atividadeId || route.params.atividadeId || atividade.value?.id;
  if (!targetId) return;

  try {
    carregando.value = true;
    await participantesAtividadeService.desinscreverUsuario(targetId, user);

    isInscrito.value = false;

    toast.info("Sua inscrição nesta atividade foi cancelada.", {
      titulo: "Inscrição cancelada",
      duracao: 5000,
    });

    await carregarAtividade();
    await analiseInscricao();
  } catch (error) {
    console.error("Erro ao cancelar inscrição:", error);
    toast.erro(
      error?.response?.data?.message ||
      error?.message ||
      "Erro ao cancelar inscrição. Tente novamente.",
      { titulo: "Erro ao cancelar" }
    );
  } finally {
    carregando.value = false;
  }
}

// 1. Monitora se a prop atividadeId mudar (caso venha via pai)
watch(
  () => props.atividadeId,
  async (newValue) => {
    if (newValue) {
      await carregarAtividade();
      await verificarPermissaoVerInscritos();
    }
  }
);

// 2. Monitora se o ID da rota mudar (caso a navegação seja por router.push)
watch(
  () => route.params.id,
  async (newAcaoId) => {
    await carregarAcao();
  }
);

// Função auxiliar para centralizar a carga inicial e re-carga
async function carregarDadosGerais() {
  const user = userInfos.getUserInfos();
  if (user) {
    isUsuarioLogado.value = true;
  }
  await carregarAtividade();
  await carregarAcao();
}

// 3. Ciclo de vida inicial
onMounted(async () => {
  timerInterval = setInterval(() => {
    agora.value = Date.now();
  }, 1000);

  carregando.value = true;
  await carregarDadosGerais();
  await verificarPermissaoVerInscritos();
  carregando.value = false;
});

onUnmounted(() => {
  if (timerInterval) {
    clearInterval(timerInterval);
  }
  _permissaoVerificadaParaAcaoId = null;
});

async function analiseInscricao() {
  isInscrito.value = false;
  const user = userInfos.getUserInfos();
  if (user) {
    try {
      const targetId =
        props.atividadeId || route.params.atividadeId || atividade.value?.id;
      if (targetId) {
        const inscrito =
          await participantesAtividadeService.isUsuarioLogadoInscrito(targetId);
        isInscrito.value = !!inscrito;
      }
    } catch (error) {
      console.error("Erro ao analisar inscrição:", error);
    }
  }
}

async function buscarEncontros() {
  const userName =
    userInfos.getUserInfos() != null
      ? userInfos.getUserInfos().nome
      : "Usuario não logado";
  if (userName != "Usuario não logado") {
    carregando.value = true;

    const atividadeId = atividade.value.id;
    try {
      encontros.value = await encontrosService.getEncontros(
        0,
        1000,
        atividadeId
      );
    } catch (error) {
      console.error("Erro ao buscar ocorrências:", error);
    } finally {
      carregando.value = false;
    }
  }
}
async function concluirAtividade() {
  // 1. Verificar se a atividade pode ser concluída
  if (
    dadosAtividade.value?.status === "CONCLUIDA" ||
    dadosAtividade.value?.status === "FINALIZADO"
  ) {
    alert("Esta atividade já foi concluída.");
    return;
  }

  if (dadosAtividade.value?.status !== "EM_EXECUCAO") {
    alert("Somente atividades em execução podem ser concluídas.");
    return;
  }

  // 2. Verificar encontros pendentes (não concluídos nem cancelados)
  const STATUS_PENDENTE = ["PROGRAMADO", "EM_EXECUCAO", "INSCRICOES_ABERTAS"];
  const encontrosPendentes = (encontros.value || []).filter((e) =>
    STATUS_PENDENTE.includes(e.status)
  );

  if (encontrosPendentes.length > 0) {
    const titulos = encontrosPendentes
      .map((e) => `  - ${e.titulo || e.descricao || "Encontro sem título"}`)
      .join("\n");
    alert(
      `Não é possível concluir a atividade.\n\nOs seguintes encontros ainda estão pendentes:\n\n${titulos}\n\nConclua ou cancele todos os encontros antes de concluir a atividade.`
    );
    return;
  }

  // 3. Confirmar a conclusão
  const confirmar = confirm(
    `Deseja realmente concluir a atividade "${dadosAtividade.value?.nome}"?\n\nEssa ação irá alterar o status da atividade para Concluída.`
  );
  if (!confirmar) return;

  // 4. Chamar o backend
  try {
    await atividadeService.concluirAtividade(atividade.value.id);
    // Recarregar dados da atividade para refletir o novo status
    atividade.value = await atividadeService.getAtividadeId(props.atividadeId);
    alert("Atividade concluída com sucesso!");
  } catch (error) {
    console.error("Erro ao concluir atividade:", error);
    alert("Ocorreu um erro ao concluir a atividade. Tente novamente.");
  }
}
async function concluirEncontro(encontroId) {
  // Verificar participantes com frequência pendente
  try {
    const atividadeId = atividade.value?.id;
    const [frequencias, participantes] = await Promise.all([
      frequenciaService.getFrequencia(encontroId),
      atividadeId
        ? participantesAtividadeService.getParticipantesAtividade(
            0,
            500,
            atividadeId
          )
        : Promise.resolve([]),
    ]);

    const idsComFrequencia = new Set(
      (frequencias || []).map((f) => f.participanteId)
    );

    const pendentes = (participantes || []).filter(
      (p) => !idsComFrequencia.has(p.participanteId)
    );

    if (pendentes.length > 0) {
      const nomes = pendentes
        .map((p) => p.nomeParticipante || p.nome)
        .join("\n  - ");
      const prosseguir = confirm(
        `Atenção! Os seguintes participantes ainda estão com frequência PENDENTE:\n\n  - ${nomes}\n\nDeseja concluir o encontro mesmo assim?`
      );
      if (!prosseguir) return;
    } else {
      const confirmacao = confirm("Deseja realmente concluir este encontro?");
      if (!confirmacao) return;
    }
  } catch (error) {
    console.error("Erro ao verificar frequências pendentes:", error);
    const confirmacao = confirm(
      "Não foi possível verificar as frequências. Deseja concluir o encontro mesmo assim?"
    );
    if (!confirmacao) return;
  }

  try {
    await encontrosService.concluirEncontro(encontroId);
    await buscarEncontros();
  } catch (error) {
    console.error("Erro ao concluir encontro:", error);
  }
}

async function baixarListaAssinatura(encontroId) {
  try {
    const data = await encontrosService.downloadListaAssinatura(encontroId);
    if (data) {
      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `lista_assinatura_${encontroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Erro ao realizar download:", error);
  }
}

async function baixarCertificado() {
  try {
    const data = await certificadoService.baixarCertificado(props.atividadeId);
    if (data && (data.size > 0 || data.byteLength > 0)) {
      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `declaracao_${props.atividadeId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      alert("Você não possui certificados disponíveis para esta atividade.");
    }
  } catch (error) {
    console.error("Erro ao baixar certificado:", error);
    alert("Você não possui certificados disponíveis para esta atividade.");
  }
}

async function baixarCsvFrequencia() {
  try {
    baixandoCsv.value = true;
    const targetAtividadeId =
      props.atividadeId ||
      atividade.value?.id ||
      route.params.atividadeId ||
      route.params.id;
    const response =
      await certificadoService.exportarAprovadosPlanilha(targetAtividadeId);
    const data = response?.data || response;
    if (data) {
      const blob = new Blob([data], {
        type: "text/csv;charset=utf-8;",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      const nomeAtividade =
        dadosAtividade.value?.nome || atividade.value?.nome || "";
      const nomeSanitizado = nomeAtividade
        ? nomeAtividade
            .trim()
            .replace(/[\\/:*?"<>|]/g, "")
            .replace(/\s+/g, "_")
        : "";

      a.download = nomeSanitizado
        ? `participantes_aprovados_${nomeSanitizado}.csv`
        : "participantes_aprovados.csv";

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Erro ao baixar CSV:", error);
    alert("Erro ao baixar CSV de frequência.");
  } finally {
    baixandoCsv.value = false;
  }
}
const baixandoPlanilha = baixandoCsv;
const baixarPlanilhaFrequencia = baixarCsvFrequencia;

async function baixarMapaFrequencia() {
  try {
    const data = await frequenciaService.baixarMapaDeFrequencia(
      atividade.value.id
    );
    if (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `mapa_frequencia_${atividade.value.id}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Erro ao baixar mapa de frequência:", error);
    alert("Erro ao baixar mapa de frequência. Tente novamente.");
  }
}
</script>

<style scoped>
#top-content-atividade {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

#titulo-e-acoes {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  margin-bottom: 24px;
}

#titulo-atividade {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.status-badge-wrapper {
  display: flex;
  align-items: center;
}

.header-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
  margin-top: 4px;
}

#botoes-coordenador,
#botoes-participante {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
}

.btn-certificado {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 20px;
  background-color: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 99px;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-certificado:hover {
  background-color: var(--roxo-escuro1);
}

.btn-editar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 20px;
  background-color: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 99px;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-editar:hover {
  background-color: var(--roxo-escuro1);
}

.btn-cancelar-atividade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 20px;
  background-color: white;
  color: #dc3545;
  border: 1px solid #dc3545;
  border-radius: 99px;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-cancelar-atividade:hover {
  background-color: #dc3545;
  color: white;
}

#texto-centralizado {
  text-align: center;
}

#descricao-atividade {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#conteudo {
  padding-top: 2%;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
}

#topo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

#inferior {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 60px;
  width: 100%;
}

#coluna-direita-inferior {
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;
}

#coluna-direita-topo {
  width: 48%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#infos-grid {
  margin-top: 20px;
}

#descricao {
  display: block;
  margin-bottom: 24px;
  text-align: justify;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.6;
  font-size: 0.95rem;
}

#rotulo-descricao {
  display: inline;
  margin: 0;
  margin-right: 5px;
  white-space: nowrap;
  font-weight: 700;
  color: #343a40;
}

#conteudo-descricao {
  display: inline;
  word-break: break-word;
  overflow-wrap: anywhere;
  color: #495057;
  font-weight: 400;
}

#info-em-linha {
  display: inline-block;
  margin-right: 68px;
}

.btn-ver-inscritos {
  display: inline-block;
  background: none;
  border: none;
  color: var(--azul-escuro);
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: inherit;
  margin-left: 8px;
}

.btn-ver-inscritos:hover {
  color: var(--roxo-claro);
}

#acoes-coordenador {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 0;
  margin-top: 0;
}

#acoes-coordenador h6 {
  font-size: 15px;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 15px;
  line-height: 100%;
  padding-bottom: 1%;
}

#opcoes {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 5%;
}

#opcoes button {
  padding: 12px 24px;
  background-color: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;
}

#opcoes button:hover {
  background-color: var(--roxo-escuro1);
}

#objetivos-relacionados {
  margin-top: 0;
  margin-left: 0;
  margin-bottom: 24px;
}

#objetivos-relacionados h6 {
  font-size: 15px;
  font-weight: 600;
  padding-bottom: 1%;
  line-height: 100%;
}

#objetivos-relacionados p {
  margin-top: 24px;
}

.objetivo-relacionado-item {
  background-color: #f8f9fa;
  border-left: 4px solid var(--roxo-claro);
  padding: 12px 16px;
  margin-top: 12px;
  border-radius: 4px;
}

.objetivo-relacionado-item p {
  margin: 4px 0 0 0 !important;
  font-size: 0.9rem;
  color: #333;
}

.objetivo-titulo {
  font-weight: 600;
  font-size: 0.95rem !important;
  color: #000 !important;
  margin-top: 0 !important;
}

#infos {
  width: 100%;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

#rotulo-infos {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--roxo-claro);
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
  display: block;
}

.infos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 24px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #868e96;
}

.info-label i {
  font-size: 0.9rem;
  color: var(--roxo-claro);
}

.info-value {
  font-size: 0.92rem;
  color: #343a40;
  font-weight: 500;
  line-height: 1.5;
}

.vagas-esgotadas {
  color: #d32f2f;
  font-weight: 700;
}

.info-item-explicacao {
  grid-column: 1 / -1;
  background-color: hsl(258, 20%, 98%);
  border: 1px solid hsl(258, 25%, 92%);
  border-radius: 8px;
  padding: 10px 12px;
}

.info-explicacao-texto {
  font-size: 0.84rem;
  color: #495057;
  line-height: 1.45;
}

.link-formulario-externo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--roxo-claro);
  font-weight: 600;
  text-decoration: none;
  font-size: 0.88rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.link-formulario-externo:hover {
  text-decoration: underline;
  color: var(--roxo-escuro1);
}

.btn-ver-inscritos {
  display: inline-block;
  background: none;
  border: none;
  color: var(--roxo-claro);
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: 0.9rem;
  font-weight: 600;
  margin-top: 4px;
  transition: color 0.2s;
}

.infos-rodape {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.btn-ver-inscritos-card {
  width: 100%;
  background-color: var(--roxo-claro);
  color: #ffffff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.btn-ver-inscritos-card:hover {
  background-color: var(--azul-escuro);
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

#topo h6 {
  padding-bottom: 1%;
  line-height: 100%;
  font-size: 15px;
  font-weight: 600;
}

#inferior h6 {
  padding-bottom: 1%;
  line-height: 100%;
  font-size: 15px;
  font-weight: 600;
}

#img {
  position: relative;
  overflow: hidden;
  color: var(--branco);
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 48%;
  height: 400px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 16px -2px rgba(54, 32, 101, 0.08), 0 2px 6px -1px rgba(54, 32, 101, 0.04);
  border: 1.5px solid hsl(258, 30%, 90%);
  flex-shrink: 0;
}

#img h3 {
  position: absolute;
}

#img figure {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
}

#encontros {
  margin-top: 0;
  width: 48%;
}

#body-encontros {
  width: 100%;
  margin-bottom: 10px;
}

.infos-encontros {
  display: flex;
  flex-direction: column;
}

.encontro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-radius: 0 25px 25px 0;
  background-color: var(--azul-escuro);
  color: var(--branco);
  cursor: pointer;
}

.encontro-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
}

.encontro-chevron {
  font-style: normal;
  font-size: 1.2rem;
}

.encontro-status-info {
  font-size: 0.85rem;
  opacity: 0.9;
}

.sem-borda-inferior {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  transition: border-radius 0.2s;
}

.descricao-encontros {
  color: var(--branco);
  padding: 20px;
  margin-top: 0;
  background-color: var(--roxo-escuro2);
  border-radius: 0 0 20px 20px;
}

.status-atividade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 99px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
}

.em-andamento {
  background-color: hsl(142, 70%, 90%);
  color: hsl(142, 70%, 25%);
}

.programada {
  background-color: hsl(210, 80%, 90%);
  color: hsl(210, 80%, 30%);
}

.concluida,
.encerrada {
  background-color: hsl(142, 60%, 80%);
  color: hsl(142, 60%, 20%);
}

.cancelada {
  background-color: hsl(0, 80%, 90%);
  color: hsl(0, 80%, 35%);
}

.aberta {
  background-color: hsl(278, 60%, 90%);
  color: hsl(278, 60%, 30%);
}

.finalizando {
  background-color: hsl(221, 50%, 85%);
  color: hsl(221, 50%, 25%);
}

.inscricoes-encerradas {
  background-color: hsl(38, 90%, 88%);
  color: hsl(30, 80%, 30%);
}

.confirmacao {
  margin-bottom: 24px;
  margin-top: 24px;
  display: flex;
  padding: 18px 24px;
  width: 100%;
  background-color: hsl(258, 20%, 96%);
  border: 1.5px solid hsl(258, 30%, 90%);
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
}

.confirmacao p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.confirmacao-inscrito {
  background-color: hsl(142, 60%, 94%) !important;
  border-color: hsl(142, 60%, 82%) !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
}

.confirmacao-inscrito p {
  color: hsl(142, 70%, 25%) !important;
  font-weight: 700 !important;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.confirmacao-texto-bloco {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}

.confirmacao-titulo {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.confirmacao-subtexto {
  margin: 0;
  font-size: 0.86rem;
  color: #495057;
  line-height: 1.4;
  font-weight: 400;
}

.confirmacao-inscrito .confirmacao-subtexto {
  color: hsl(142, 60%, 25%) !important;
  font-weight: 500 !important;
}

#cancelamento button {
  margin-bottom: 1%;
  height: 100%;
  width: 100%;
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  border-radius: 1.25rem;
}
.linha-info-grupo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

p {
  margin-bottom: 0;
}

hr {
  border: none;
  height: 2px;
  background-color: var(--preto);
}

/* ======================================================= */
/* Estilos do modal de confirmação de cancelamento         */
/* ======================================================= */
.overlay-cancelamento {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-cancelamento {
  background-color: var(--branco);
  border-radius: 12px;
  padding: 32px;
  width: 420px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.modal-cancelamento h6 {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--vermelho);
  margin: 0;
}

.modal-cancelamento p {
  font-size: 0.95rem;
  color: var(--preto);
  line-height: 1.5;
}

.modal-cancelamento-botoes {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
}

.btn-confirmar-cancelamento {
  padding: 8px 24px;
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: opacity 0.2s;
}

.btn-confirmar-cancelamento:hover {
  opacity: 0.85;
}

.btn-voltar-cancelamento {
  padding: 8px 24px;
  background-color: white;
  color: var(--azul-escuro);
  border: 1px solid var(--azul-escuro);
  border-radius: 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.btn-voltar-cancelamento:hover {
  background-color: #d0d0d0;
}

.encontro-acoes {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-baixar-lista {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: var(--roxo-escuro1);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
}

.btn-baixar-lista:hover {
  background-color: var(--roxo-escuro);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(54, 32, 101, 0.18);
}

.btn-concluir-encontro {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: #2e7d32;
  color: var(--branco);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
}

.btn-concluir-encontro:hover {
  background-color: #1b5e20;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.25);
}

.btn-concluir-atividade {
  padding: 8px 20px;
  background-color: #2e7d32;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: background-color 0.3s;
}

.btn-concluir-atividade:hover {
  background-color: #1b5e20;
}

/* ── Estilos da Develop: Inscrição, Encontros Acordeão e Responsividade ── */
.inscricao-topo-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.badge-inscrito-topo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background-color: hsl(142, 60%, 93%);
  color: hsl(142, 70%, 25%);
  border: 1.5px solid hsl(142, 60%, 80%);
  border-radius: 99px;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
}

.btn-cancelar-inscricao-topo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  color: #d32f2f;
  border: 1.5px solid #ef9a9a;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-cancelar-inscricao-topo:hover {
  background: #ffebee;
  border-color: #d32f2f;
}

.btn-inscrever-topo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: #5b3fa8;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(91, 63, 168, 0.25);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-inscrever-topo:hover {
  background: #4a2f90;
  transform: translateY(-1px);
}

.encontros-cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.encontros-titulo-area {
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge-contador {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: hsl(258, 40%, 93%);
  color: var(--roxo-claro);
  font-size: 0.78rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 99px;
  min-width: 20px;
}

.btn-editar-encontros {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--roxo-claro);
  background-color: hsl(258, 50%, 96%);
  border: 1px solid hsl(258, 45%, 88%);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-editar-encontros:hover {
  background-color: hsl(258, 45%, 91%);
  color: var(--roxo-escuro1);
  transform: translateY(-1px);
}

.infos-encontros {
  background: #ffffff;
  border: 1.5px solid hsl(258, 25%, 90%);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px -2px rgba(54, 32, 101, 0.06);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.infos-encontros:hover {
  border-color: hsl(258, 45%, 78%);
  box-shadow: 0 8px 24px -3px rgba(54, 32, 101, 0.14);
}

.encontro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background-color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s ease;
  user-select: none;
  gap: 12px;
}

.encontro:hover {
  background-color: hsl(260, 35%, 98.5%);
}

.encontro-titulo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 0.95rem;
  color: hsl(258, 53%, 22%);
}

.encontro-chevron {
  font-size: 1.1rem;
  color: var(--roxo-claro);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.encontro-chevron.is-rotated {
  transform: rotate(180deg);
}

.encontro-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 99px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.encontro-status-badge span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.encontro-status-badge.programado {
  background-color: hsl(207, 85%, 94%);
  color: hsl(207, 85%, 32%);
  border: 1px solid hsl(207, 80%, 86%);
}

.encontro-status-badge.em_execucao {
  background-color: hsl(29, 95%, 94%);
  color: hsl(29, 95%, 35%);
  border: 1px solid hsl(29, 90%, 86%);
}

.encontro-status-badge.finalizado {
  background-color: hsl(142, 60%, 93%);
  color: hsl(142, 70%, 26%);
  border: 1px solid hsl(142, 60%, 82%);
}

.encontro-status-badge.cancelado {
  background-color: hsl(0, 85%, 95%);
  color: hsl(0, 80%, 38%);
  border: 1px solid hsl(0, 80%, 86%);
}

.encontro-status-badge.inscricoes_abertas {
  background-color: hsl(278, 60%, 94%);
  color: hsl(278, 60%, 32%);
  border: 1px solid hsl(278, 60%, 86%);
}

.descricao-encontros {
  background-color: hsl(260, 30%, 98.5%);
  border-top: 1px dashed hsl(258, 25%, 90%);
  padding: 16px 20px;
  color: hsl(258, 15%, 32%);
  font-size: 0.92rem;
  line-height: 1.55;
}

.descricao-texto strong {
  color: hsl(258, 53%, 22%);
  margin-right: 6px;
}

.encontros-vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background-color: #ffffff;
  border: 1.5px dashed hsl(258, 25%, 88%);
  border-radius: 12px;
  color: hsl(258, 15%, 50%);
  gap: 8px;
  text-align: center;
}

.encontros-vazio i {
  font-size: 2rem;
  color: hsl(258, 20%, 75%);
}

.encontros-vazio p {
  margin: 0;
  font-size: 0.95rem;
}

/* Transição de acordeão suave */
.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 500px;
  opacity: 1;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
  transform: translateY(-6px);
  overflow: hidden;
}

.confirmacao-inscrito {
  background-color: hsl(142, 60%, 94%) !important;
  border-color: hsl(142, 60%, 82%) !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
}

.confirmacao-inscrito p {
  color: hsl(142, 70%, 25%) !important;
  font-weight: 700 !important;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.btn-desinscrever-banner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  background-color: hsl(0, 75%, 97%);
  color: hsl(0, 75%, 45%);
  border: 1.5px solid hsl(0, 70%, 85%);
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-desinscrever-banner:hover {
  background-color: hsl(0, 80%, 92%);
  border-color: hsl(0, 75%, 70%);
  color: hsl(0, 80%, 35%);
  transform: translateY(-1px);
}

.confirmacao-inscricoes-encerradas {
  background-color: hsl(38, 100%, 96%) !important;
  border-color: hsl(38, 90%, 80%) !important;
}

.confirmacao-inscricoes-encerradas .confirmacao-titulo {
  color: hsl(30, 80%, 35%) !important;
}

.confirmacao-inscricoes-encerradas .confirmacao-subtexto {
  color: hsl(30, 60%, 45%) !important;
}

.confirmacao-aberta {
  background-color: hsl(278, 60%, 96%) !important;
  border-color: hsl(278, 50%, 88%) !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
}

.confirmacao-aberta p {
  color: hsl(278, 60%, 30%) !important;
  font-weight: 600 !important;
  font-size: 1rem;
  margin: 0;
}

.btn-inscrever-banner {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #5b3fa8;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(91, 63, 168, 0.25);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-inscrever-banner:hover {
  background: #4a2f90;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(91, 63, 168, 0.35);
}

@media (max-width: 900px) {
  #topo {
    flex-direction: column;
    gap: 20px;
  }

  #img {
    width: 100%;
    max-width: 100%;
    min-height: 260px;
    height: 280px;
    max-height: none;
  }

  #coluna-direita-topo {
    width: 100%;
  }
}
</style>
